/**
 * La simulation s'arrête quand un appareil tactile est tenu en portrait (l'overlay « Tournez votre téléphone »
 * est affiché) : on ne laisse pas les monstres tuer le joueur derrière un écran qu'il ne peut pas utiliser.
 */
export function shouldRunSimulation(portrait: boolean, coarse: boolean): boolean {
  return !(portrait && coarse);
}

export function isPortrait(): boolean {
  try { return window.matchMedia('(orientation: portrait)').matches; } catch { return false; }
}
